import antd from 'ant-design-vue/es/locale/en_US'

import { flattenMap } from '@/utils/locale'
import layout from './en-US/layout'
import okr from './en-US/okr'
import guide from './en-US/guide'
import shared from './en-US/shared'
import bestCase from './en-US/best-case'
import changelog from './en-US/changelog'
import statistic from './en-US/statistic'
import weekly from './en-US/weekly'

const components = {
  antLocale: antd
}

export default {
  ...components,
  ...flattenMap({
    layout,
    okr,
    guide,
    shared,
    weekly
  }),
  bestCase,
  changelog,
  statistic
}
